export default __webpack_public_path__ + "static/media/car-seat.cc5ae93d.svg";